import React from "react";
import PropTypes from "prop-types";
import urlJoin from "url-join";
import classnames from "classnames";
import { connect } from "react-redux";
import { Notification, showNotification } from "react-admin";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import history from "../common/history";
import TranslatedText from "./TranslatedText";
import defaultTheme from "../common/themes";
import tccStyles from "../common/styles";
import LoginForm from "./MyLoginForm";

import {
    API_URL,
    MYSECRET_KEY,
    STATE,
    AUTHORIZE_CHECK,
    ENV_NAME,
    LOGIN_TSID
} from "../config";
const crypto = require("crypto");

const styles = theme => ({
    main: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        //height: "1px",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundSize: "cover"
    },
    card: {
        minWidth: 400,
        marginTop: "2em",
        minHeight: 150
    },
    avatar: {
        margin: "1em",
        display: "flex",
        justifyContent: "center"
    },
    icon: {
        backgroundColor: theme.palette.secondary[500]
    },
    link: {
        width: "90%",
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 20,
        color: "black",
        background: "white",
        paddingButtom: 30
    },
    infoline: {
        marginTop: 6
    },
    infolineIcon: { color: tccStyles.login.infoline.iconColor },
    infolineIconBox: { position: "relative", top: 6 },
    appTitle: { textAlign: "center", marginTop: 40 },
    appLogo: { paddingTop: 70, textAlign: "center" },
    appHeader: {
        height: "6px",
        width: "100%",
        top: 0,
        position: "fixed",
        zIndex: 1000
    }
});

const loginFormStyles = () => ({
    button: {
        backgroundColor: tccStyles.login.button.backgroundColor
    }
});

const getAuthorizeEndpointUrl = () => {
    return AUTHORIZE_CHECK[ENV_NAME].url;
};

const createUrl = (base_url, params) => {
    const url = new URL(base_url);
    if (params) {
        Object.keys(params).forEach(key =>
            url.searchParams.append(key, params[key])
        );
    }
    return url.toString();
};

const getTSIDv3AuthUrl = (
    client_id,
    redirect_uri,
    state = null,
    spid_level = null,
    idp = null,
    test_stage = false
) => {
    const params = {
        client_id,
        response_type: "code",
        redirect_uri,
        scope: "openid profile offline_access"
    };
    if (state) {
        params.state = state;
    }
    const acr_values = [];
    if (spid_level) {
        acr_values.append(`spid_level:${spid_level}`);
    }
    if (idp) {
        acr_values.append(`idp:${idp}`);
    }
    if (acr_values.length > 0) {
        params["acr_values"] = acr_values.join(" ");
    }
    return createUrl(getAuthorizeEndpointUrl(test_stage), params);
};

function encodeUrlSafeBase64(data) {
    return Buffer.from(data)
        .toString("base64")
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}

function encryptStringAES(text, secretKey) {
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv(
        "aes-256-gcm",
        Buffer.from(secretKey, "utf-8"),
        iv
    );
    let encrypted = cipher.update(text, "utf-8", "hex");
    encrypted += cipher.final("hex");
    const authTag = cipher.getAuthTag();

    return `${iv.toString("hex")}:${encrypted}:${authTag.toString("hex")}`;
}

const handleLoginWithTeamSystemId = async () => {
    const request = new Request(urlJoin(API_URL, "/tsid_check"), {
        method: "GET",
        mode: "cors",
        headers: new Headers({
            "Content-Type": "application/json"
        }),
        credentials: "include"
    });
    let response = await fetch(request);
    if (response.status !== 200) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        response = await fetch(request);
        if (response.status !== 200) {
            history.push(`/login_offline`);
            return;
        }
    }

    const authUrl = getTSIDv3AuthUrl(
        AUTHORIZE_CHECK[ENV_NAME].client_id,
        API_URL + "/login_tsid",
        encodeUrlSafeBase64(encryptStringAES(STATE, MYSECRET_KEY)),
        null,
        null,
        null
    );
    window.location.href = authUrl;
};

const MyLoginForm = withStyles(loginFormStyles)(LoginForm);

const sanitizeRestProps = ({
    classes,
    className,
    location,
    title,
    array,
    theme,
    staticContext,
    ...rest
}) => rest;

const Login = ({ classes, className, loginForm, dispatch, ...rest }) => {
    const fullUrl = window.location.href;
    const queryString = fullUrl.split("?")[1];
    const urlParams = new URLSearchParams(queryString);
    const msg = urlParams.get("message");
    if (msg) {
        dispatch(showNotification(msg, "warning"));
    }
    return (
        <div
            className={classnames(classes.main, className)}
            {...sanitizeRestProps(rest)}
        >
            <img
                src="/static/images/sfondo_header.png"
                alt="sfondo"
                className={classes.appHeader}
            />
            <div className={classes.appLogo}>
                <img
                    src="/static/images/logo_ts.png"
                    alt="Logo"
                    width="100px"
                />
            </div>
            <span className={classes.appTitle}>
                <Typography component="h2" variant="display1">
                    TeamSystem Cloud Console
                </Typography>
            </span>
            <Card className={classes.card}>
                <div className={classes.avatar}>
                    <Avatar className={classes.icon}>
                        <LockIcon />
                    </Avatar>
                </div>
                {LOGIN_TSID !== "false" && (
                    <div className={classes.avatar}>
                        <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            onClick={handleLoginWithTeamSystemId}
                            disabled={false}
                            className={classes.button}
                        >
                            Accedi con il TeamSystem ID
                        </Button>
                    </div>
                )}
                {LOGIN_TSID === "false" && (
                    <div>
                        <MyLoginForm />
                        <Button
                            type="submit"
                            variant="outlined"
                            onClick={() => {
                                history.push(`/reset_password`);
                            }}
                            disabled={false}
                            className={classes.link}
                        >
                            <TranslatedText resource_name="ra.auth.pwd_forgot" />
                        </Button>
                        <span className={classes.infoline}>
                            <span className={classes.infolineIconBox}>
                                <InfoIcon className={classes.infolineIcon} />
                            </span>
                            <span>
                                <TranslatedText resource_name="insert_user_credentials" />
                            </span>
                        </span>
                    </div>
                )}
            </Card>
            <Notification />
        </div>
    );
};

Login.propTypes = {
    className: PropTypes.string,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    input: PropTypes.object,
    meta: PropTypes.object,
    previousRoute: PropTypes.string,
    dispatch: PropTypes.func.isRequired
};

Login.defaultProps = {
    theme: defaultTheme
};

export default connect()(withStyles(styles)(Login));



// WEBPACK FOOTER //
// ./src/components/MyLoginPage.js